<ng-container *ngTemplateOutlet="captionTemplate ? captionTemplate: defaultCaption">
</ng-container>

<ng-template #defaultCaption>
  <div *ngIf="searchCaptionTemplate" class="p-grid caption-wrapper">
    <ng-container *ngTemplateOutlet="searchCaptionTemplate"></ng-container>
  </div>
  <div class="p-grid caption-wrapper">
    <div class="p-col-12 p-md-6 p-lg-4 caption-left">
      <ng-container *ngTemplateOutlet="leftCaptionTemplate"></ng-container>
    </div>
    <div class="p-col-12 p-md-6 p-lg-4 caption-center">
      <span *ngIf="!disableSearch" class="p-input-icon-left">
        <i class="pi pi-search"></i>
        <input pInputText id="searchInput" type="text" [placeholder]="PrimeNgConfig.TableFilterPlaceholder"
               (input)="dt.filterGlobal($event.target.value, 'contains')"/>
      </span>
      <button *ngIf="!disableSearch" pButton type="button" class="action-icon filter-reset" icon="pi pi-times"
              (click)="primeNgService.resetTableFilter(dt, 'searchInput')">
      </button>
      <app-data-table-export *ngIf="enabledExport"
                             [value]="value" [columns]="dt.columns"
                             [exportUsingTableColumn]="exportUsingTableColumn" [exportTableColumns]="exportTableColumns" [exportFileName]="exportFileName">
      </app-data-table-export>
    </div>
    <div class="p-col-12 p-md-12 p-lg-4 caption-right">
      <ng-container *ngTemplateOutlet="rightCaptionTemplate"></ng-container>
    </div>
  </div>
</ng-template>
